/* eslint-disable react-hooks/exhaustive-deps */
import { getAuth, signOut } from 'firebase/auth';
import React, { useEffect, useState,useRef } from 'react';
import { FaHistory, FaShippingFast, FaUserCog, FaSignOutAlt, FaEdit, FaEye, FaMapMarkerAlt, FaUser, FaEnvelope, FaPhone, FaChevronRight, FaPlus } from 'react-icons/fa';
import { app, db } from '../../Admin/Config/Config';
import { useLoginPopup } from '../../Auth/LoginContext';
import { collection, doc, getDocs, limit, orderBy, query, startAfter, updateDoc, where } from 'firebase/firestore';
import { useToast } from '../../Toast.jsx/Toast';
import { useNavigate } from 'react-router-dom';
import Profileempty from './Profileempty';

const ProfilePage = (user) => {
  const [activeSection, setActiveSection] = useState("Account Settings");
  const { openPopup } = useLoginPopup();
  const { showSuccess, showWarning } = useToast();
  const navigate = useNavigate();
  const auth = getAuth(app);

  useEffect(() => {
    if (!auth.currentUser) {
      openPopup();
    }
  }, [auth]);

  // =================== Edit Profile ================ //
  const [editFlag, setEditFlag] = useState(false);
  const [userInfo, setUserInfo] = useState({
    name: user.name,
    mobile: user.mobile,
  });
  const handleSaveProfile = async (e) => {
    e.preventDefault();
    const userref = doc(db, "users", auth.currentUser.uid);
    await updateDoc(userref, {
      name: userInfo.name,
      mobile: userInfo.mobile,
    });
    showSuccess("Profile updated successfully");
    setEditFlag(false);
  };

  // =================== Orders History ================ //
  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
const fetchOrders = async (lastVisibleDoc = null) => {
  const datas = [];
  const ref = collection(db, "orders");
  let q = query(
    ref,
    where("uid", "==", auth.currentUser.uid),
    orderBy("orderDate", "desc"),
    limit(10)
  );
  if (lastVisibleDoc) {
    q = query(q, startAfter(lastVisibleDoc));
  }

  const docs = await getDocs(q);

  if (docs.docs.length === 0) {
    return { datas: [], lastVisible: null }; // No more documents
  }

  docs.forEach((doc) => {
    datas.push({
      id: doc.id,
      ...doc.data(),
      label:
        doc.data().order_status === "pending"
          ? "Order placed"
          : capitalizeFirstLetter(doc.data().order_status),
    });
  });

  const lastVisible = docs.docs[docs.docs.length - 1];
  return { datas, lastVisible };
};


  const [orders, setOrders] = useState([]);
  const [lastVisibleDoc, setLastVisibleDoc] = useState(null);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true); // Track if there are more orders to load

  const loadMoreOrders = async () => {
    if (!auth.currentUser || !hasMore || loading) return; // Prevent further calls if no more orders
    setLoading(true);

    const { datas, lastVisible } = await fetchOrders(lastVisibleDoc);

    if (datas.length === 0) {
      setHasMore(false); // No more orders to load
    } else {
      setOrders((prevOrders) => [...prevOrders, ...datas]);
      setLastVisibleDoc(lastVisible);
    }

    setLoading(false);
  };
  useEffect(() => {
    const loadInitialOrders = async () => {
      const { datas, lastVisible } = await fetchOrders();
      setOrders(datas);
      setLastVisibleDoc(lastVisible);
    };
    if (auth.currentUser) {
      loadInitialOrders();
    }
  }, []);

  // ================== Manage Adrress ================ //
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleSaveClick = async () => {
    const hasEmptyField = Object.values(address).some(
      (value) => value === "" || value === null || value === undefined
    );
    if (hasEmptyField) {
      showWarning("Please fill all the fields");
    } else {
      await updateDoc(
        doc(db, "users", auth.currentUser.uid, "address", address.id),
        {
          ...address,
        }
      );
      showSuccess("Address updated successfully");
      await fetchAddress();
      setIsModalOpen(false);
    }
  };
  const handleOpenModal = (address) => {
    setIsModalOpen(true);
    setchangeAddress(address.country);
    setaddress(address);
  };
  const [addresses, setAddresses] = useState([]);
  const [address, setaddress] = useState({});

  const fetchAddress = async () => {
    setAddresses([]);
    const ref = collection(db, "users", auth.currentUser.uid, "address");
    const querySnapshot = await getDocs(ref);
    const add = [];
    querySnapshot.forEach((doc) => {
      add.push({ id: doc.id, ...doc.data() });
    });
    setAddresses(add);
  };
  useEffect(() => {
    if (auth.currentUser) {
      fetchAddress();
    }
  }, []);
  // =============================== Fetch Countries ================================ //
  const handleCountryChange = (e) => {
    const countryName = e.target.value;
    setaddress({ ...address, country: countryName });
  };
  const setchangeAddress = (value) => {
    const countryName = value;
    setaddress({ ...address, country: countryName });
  };

  // ============================= Format Address ================================ //
  const formatAddress = (address) => {
    const { name, street, city, state, zip, country } = address;
    return `${name ? name + ", " : ""}${street ? street + ", " : ""}${
      city ? city + ", " : ""
    }${state ? state + ", " : ""}${zip ? zip + ", " : ""}${
      country ? country : ""
    }`.trim();
  };

  const mainContentRef = useRef(null);

  const handleSectionClick = (sectionName) => {
    setActiveSection(sectionName);

    if (window.innerWidth <= 768 && mainContentRef && mainContentRef.current) {
      mainContentRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  const renderSectionContent = () => {
    switch (activeSection) {
      case "Order History":
        return (
          <div className="space-y-6">
            {orders.map((order) => (
              <div key={order.id} className="group bg-white rounded-xl border border-gray-100 shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden">
                <div className="p-4 sm:p-6">
                  <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start mb-4 space-y-3 sm:space-y-0">
                    <div className="flex items-center space-x-3">
                      <div className="w-3 h-3 bg-gradient-to-r from-red-500 to-pink-500 rounded-full animate-pulse"></div>
                      <h3 className="font-semibold text-gray-900 text-base sm:text-lg">
                        Order #{order.order_id}
                      </h3>
                    </div>
                    <div className="text-left sm:text-right">
                      <p className="text-xl sm:text-2xl font-bold text-gray-900">
                        ${order.offerPriceTotal}
                      </p>
                      <p className="text-xs sm:text-sm text-gray-500">
                        {new Date(order.orderDate.seconds * 1000).toLocaleDateString("en-US", {
                          year: 'numeric',
                          month: 'short',
                          day: 'numeric'
                        })}
                      </p>
                    </div>
                  </div>
                  
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4 mb-6">
                    <div className="flex items-center space-x-3 p-3 bg-red-50 rounded-lg">
                     
                      <div>
                        <p className="text-xs sm:text-sm text-gray-600">Items</p>
                        <p className="font-semibold text-gray-900 text-sm sm:text-base">{order.items.length} products</p>
                      </div>
                    </div>
                    
                    <div className="flex items-center space-x-3 p-3 bg-white border border-red-200 rounded-lg">
                     
                      <div>
                        <p className="text-xs sm:text-sm text-gray-600">Order Date</p>
                        <p className="font-semibold text-gray-900 text-sm sm:text-base">
                          {new Date(order.orderDate.seconds * 1000).toLocaleDateString("en-US")}
                        </p>
                      </div>
                    </div>
                    
                    <div className="flex items-center space-x-3 p-3 bg-red-50 rounded-lg sm:col-span-2 lg:col-span-1">
                      
                      <div>
                        <p className="text-xs sm:text-sm text-gray-600">Status</p>
                        <p className="font-semibold text-gray-900 text-sm sm:text-base">{order.label}</p>
                      </div>
                    </div>
                  </div>
                  
                  <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between space-y-3 sm:space-y-0">
                    <span className={`inline-flex items-center px-3 sm:px-4 py-2 rounded-full text-xs sm:text-sm font-medium ${
                      order.label === "Order placed" 
                        ? "bg-red-100 text-red-800 border border-red-200"
                        : order.label === "Delivered"
                        ? "bg-white text-red-600 border border-red-300"
                        : "bg-red-50 text-red-700 border border-red-200"
                    }`}>
                      <div className={`w-2 h-2 rounded-full mr-2 ${
                        order.label === "Order placed" ? "bg-red-500" :
                        order.label === "Delivered" ? "bg-red-600" : "bg-red-500"
                      }`}></div>
                      {order.label}
                    </span>
                    
                    <button
                      onClick={() =>
                        navigate("/orderhistory", {
                          state: {
                            order: { id: order.id },
                          },
                        })
                      }
                      className="group-hover:bg-red-600 bg-gray-100 text-gray-700 hover:text-white transition-all duration-300 px-4 sm:px-6 py-2 sm:py-3 rounded-lg font-medium flex items-center justify-center space-x-2 text-sm sm:text-base"
                    >
                      <FaEye className="text-sm" />
                      <span>View Details</span>
                      <FaChevronRight className="text-xs" />
                    </button>
                  </div>
                </div>
              </div>
            ))}
            
            {orders && orders.length ? (
              <div className="flex justify-center items-center pt-8">
                <button
                  className={`px-8 py-4 rounded-xl font-medium transition-all duration-300 ${
                    loading || !hasMore
                      ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                      : "bg-gradient-to-r from-red-600 to-pink-600 text-white hover:from-red-700 hover:to-pink-700 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
                  }`}
                  onClick={loadMoreOrders}
                  disabled={loading || !hasMore}
                >
                  {loading ? (
                    <div className="flex items-center space-x-3">
                      <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                      <span>Loading...</span>
                    </div>
                  ) : hasMore ? (
                    "Load More Orders"
                  ) : (
                    "No More Orders"
                  )}
                </button>
              </div>
            ) : (
              <div className="text-center py-12 sm:py-16">
                <div className="mb-6 sm:mb-8">
                  <div className="w-20 h-20 sm:w-24 sm:h-24 bg-gradient-to-br from-gray-100 to-gray-200 rounded-full flex items-center justify-center mx-auto shadow-lg">
                    <span className="text-3xl sm:text-4xl">📦</span>
                  </div>
                </div>
                <h3 className="text-lg sm:text-xl font-bold text-gray-800 mb-2 sm:mb-3">No Orders Yet</h3>
                <p className="text-gray-500 mb-4 sm:mb-6 max-w-md mx-auto text-sm sm:text-base px-4">Start shopping to see your order history here. Your first order will appear in this section.</p>
                <button className="px-6 sm:px-8 py-3 sm:py-4 bg-gradient-to-r from-red-600 to-pink-600 text-white rounded-xl hover:from-red-700 hover:to-pink-700 transition-all duration-300 font-medium shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 text-sm sm:text-base">
                  Start Shopping
                </button>
              </div>
            )}
          </div>
        );
      case "Shipping Addresses":
        return (
          <div className="space-y-6">
            {addresses && addresses.length > 0 ? (
              addresses.map((address, index) => (
                <div key={address.id} className="group bg-white rounded-xl border border-gray-100 shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden">
                  <div className="p-4 sm:p-6">
                    <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start mb-4 space-y-3 sm:space-y-0">
                      <div className="flex items-center space-x-3 sm:space-x-4">
                        <div className="relative">
                          <div className="w-10 h-10 sm:w-12 sm:h-12 bg-gradient-to-br from-red-500 to-pink-500 rounded-full flex items-center justify-center shadow-lg">
                            <FaMapMarkerAlt className="text-white text-base sm:text-lg" />
                          </div>
                          <div className="absolute -top-1 -right-1 sm:-top-2 sm:-right-2 w-5 h-5 sm:w-6 sm:h-6 bg-white rounded-full flex items-center justify-center border-2 border-red-500 shadow-md">
                            <span className="text-red-600 font-bold text-xs">{index + 1}</span>
                          </div>
                        </div>
                        <div>
                          <h3 className="font-bold text-gray-900 text-lg sm:text-xl">
                            Address #{index + 1}
                          </h3>
                          <p className="text-gray-500 text-sm sm:text-base">Primary Shipping Address</p>
                        </div>
                      </div>
                      <button
                        onClick={() => handleOpenModal(address)}
                        className="group-hover:bg-red-600 bg-gray-100 text-gray-700 hover:text-white transition-all duration-300 px-4 sm:px-6 py-2 sm:py-3 rounded-lg font-medium flex items-center justify-center space-x-2 text-sm sm:text-base"
                      >
                        <FaEdit className="text-sm" />
                        <span>Edit</span>
                        <FaChevronRight className="text-xs" />
                      </button>
                    </div>
                    
                    <div className="bg-gradient-to-r from-gray-50 to-gray-100 rounded-xl p-4 sm:p-6 border border-gray-200">
                      <div className="flex items-start space-x-3">
                        <FaMapMarkerAlt className="text-red-500 mt-1 flex-shrink-0" />
                        <p className="text-gray-700 leading-relaxed text-sm sm:text-lg">{formatAddress(address)}</p>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="text-center py-12 sm:py-16">
                <div className="mb-6 sm:mb-8">
                  <div className="w-20 h-20 sm:w-24 sm:h-24 bg-gradient-to-br from-gray-100 to-gray-200 rounded-full flex items-center justify-center mx-auto shadow-lg">
                    <FaMapMarkerAlt className="text-2xl sm:text-3xl text-gray-400" />
                  </div>
                </div>
                <h3 className="text-lg sm:text-xl font-bold text-gray-800 mb-2 sm:mb-3">No Addresses Saved</h3>
                <p className="text-gray-500 mb-4 sm:mb-6 max-w-md mx-auto text-sm sm:text-base px-4">Add your first shipping address for faster checkout and better delivery experience.</p>
                <button className="px-6 sm:px-8 py-3 sm:py-4 bg-gradient-to-r from-red-600 to-pink-600 text-white rounded-xl hover:from-red-700 hover:to-pink-700 transition-all duration-300 font-medium shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 flex items-center space-x-2 mx-auto text-sm sm:text-base">
                  <FaPlus className="text-sm" />
                  <span>Add Address</span>
                </button>
              </div>
            )}
          </div>
        );
      case "Account Settings":
        return (
          <div className="space-y-8">
            {editFlag ? (
              <div className="bg-white rounded-xl border border-gray-100 shadow-sm p-4 sm:p-6 lg:p-8">
                <div className="flex items-center space-x-3 sm:space-x-4 mb-6 sm:mb-8">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-gradient-to-br from-red-500 to-pink-500 rounded-full flex items-center justify-center shadow-lg">
                    <FaUser className="text-white text-base sm:text-lg" />
                  </div>
                  <div>
                    <h3 className="text-xl sm:text-2xl font-bold text-gray-900">Edit Profile</h3>
                    <p className="text-gray-500 text-sm sm:text-base">Update your personal information</p>
                  </div>
                </div>
                
                <form onSubmit={handleSaveProfile} className="space-y-6">
                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6">
                    <div className="space-y-2">
                      <label
                        className="block text-sm font-semibold text-gray-700"
                        htmlFor="name"
                      >
                        <div className="flex items-center space-x-2">
                          <FaUser className="text-red-500" />
                          <span>Full Name</span>
                        </div>
                      </label>
                      <input
                        type="text"
                        id="name"
                        value={userInfo.name}
                        onChange={(e) =>
                          setUserInfo({ ...userInfo, name: e.target.value })
                        }
                        placeholder="Enter your full name"
                        required
                        className="w-full p-3 sm:p-4 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent transition-all duration-200 bg-gray-50 hover:bg-white"
                      />
                    </div>
                    <div className="space-y-2">
                      <label
                        className="block text-sm font-semibold text-gray-700"
                        htmlFor="phone"
                      >
                        <div className="flex items-center space-x-2">
                          <FaPhone className="text-red-500" />
                          <span>Phone Number</span>
                        </div>
                      </label>
                      <input
                        type="tel"
                        id="phone"
                        value={userInfo.mobile}
                        onChange={(e) =>
                          setUserInfo({ ...userInfo, mobile: e.target.value })
                        }
                        required
                        placeholder="Enter your phone number"
                        className="w-full p-3 sm:p-4 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent transition-all duration-200 bg-gray-50 hover:bg-white"
                      />
                    </div>
                  </div>
                  
                  <div className="flex flex-col sm:flex-row space-y-3 sm:space-y-0 sm:space-x-4 pt-6">
                    <button
                      type="button"
                      onClick={() => setEditFlag(false)}
                      className="flex-1 px-4 sm:px-6 py-3 sm:py-4 border border-gray-300 text-gray-700 rounded-xl hover:bg-gray-50 transition-all duration-200 font-medium text-sm sm:text-base"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="flex-1 px-4 sm:px-6 py-3 sm:py-4 bg-gradient-to-r from-red-600 to-pink-600 text-white rounded-xl hover:from-red-700 hover:to-pink-700 transition-all duration-200 font-medium shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 text-sm sm:text-base"
                    >
                      Save Changes
                    </button>
                  </div>
                </form>
              </div>
            ) : (
              <div className="bg-white rounded-xl border border-gray-100 shadow-sm p-4 sm:p-6 lg:p-8">
                <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start mb-6 sm:mb-8 space-y-4 sm:space-y-0">
                  <div className="flex items-center space-x-3 sm:space-x-4">
                    <div className="w-10 h-10 sm:w-12 sm:h-12 bg-gradient-to-br from-red-500 to-pink-500 rounded-full flex items-center justify-center shadow-lg">
                      <FaUser className="text-white text-base sm:text-lg" />
                    </div>
                    <div>
                      <h4 className="text-xl sm:text-2xl font-bold text-gray-900">
                        Personal Information
                      </h4>
                      <p className="text-gray-500 text-sm sm:text-base">Manage your account details</p>
                    </div>
                  </div>
                  <button
                    onClick={() => setEditFlag(true)}
                    className="px-4 sm:px-6 py-2 sm:py-3 bg-gradient-to-r from-red-600 to-pink-600 text-white rounded-xl hover:from-red-700 hover:to-pink-700 transition-all duration-200 font-medium shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 flex items-center justify-center space-x-2 text-sm sm:text-base"
                  >
                    <FaEdit className="text-sm" />
                    <span>Edit Profile</span>
                  </button>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
                  <div className="p-4 sm:p-6 bg-red-50 rounded-xl border border-red-200">
                    <div className="flex items-center space-x-3 sm:space-x-4">
                      <div className="w-8 h-8 sm:w-10 sm:h-10 bg-red-500 rounded-full flex items-center justify-center">
                        <FaUser className="text-white text-sm" />
                      </div>
                      <div className="flex-1">
                        <p className="text-gray-600 text-xs sm:text-sm font-medium">Full Name</p>
                        <p className="text-gray-900 font-bold text-sm sm:text-lg">{userInfo.name}</p>
                      </div>
                    </div>
                  </div>
                  
                  <div className="p-4 sm:p-6 bg-white rounded-xl border border-red-200">
                    <div className="flex items-center space-x-3 sm:space-x-4">
                      <div className="w-8 h-8 sm:w-10 sm:h-10 bg-red-500 rounded-full flex items-center justify-center">
                        <FaEnvelope className="text-white text-sm" />
                      </div>
                      <div className="flex-1">
                        <p className="text-gray-600 text-xs sm:text-sm font-medium">Email Address</p>
                        <p className="text-gray-900 font-bold text-sm sm:text-lg">
                          {getAuth().currentUser?.email}
                        </p>
                      </div>
                    </div>
                  </div>
                  
                  <div className="p-4 sm:p-6 bg-red-50 rounded-xl border border-red-200">
                    <div className="flex items-center space-x-3 sm:space-x-4">
                      <div className="w-8 h-8 sm:w-10 sm:h-10 bg-red-500 rounded-full flex items-center justify-center">
                        <FaPhone className="text-white text-sm" />
                      </div>
                      <div className="flex-1">
                        <p className="text-gray-600 text-xs sm:text-sm font-medium">Phone Number</p>
                        <p className="text-gray-900 font-bold text-sm sm:text-lg">{userInfo.mobile}</p>
                      </div>
                    </div>
                  </div>
                  
                  <div className="p-4 sm:p-6 bg-white rounded-xl border border-red-200">
                    <div className="flex items-center space-x-3 sm:space-x-4">
                      <div className="w-8 h-8 sm:w-10 sm:h-10 bg-red-500 rounded-full flex items-center justify-center">
                        <FaUserCog className="text-white text-sm" />
                      </div>
                      <div className="flex-1">
                        <p className="text-gray-600 text-xs sm:text-sm font-medium">Account Status</p>
                        <p className="text-gray-900 font-bold text-sm sm:text-lg">Active</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <>
      {getAuth().currentUser ? (
        <div className="min-h-screen bg-white">
          {/* Header */}
          <div className="bg-white">
            <div className="container mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
              <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between py-4 sm:py-6">
                <div className="mb-4 sm:mb-0">
                  <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">My Account</h1>
                  <p className="text-gray-500 mt-1 text-sm sm:text-base">Manage your profile and preferences</p>
                </div>
                <div className="flex items-center space-x-3 sm:space-x-4">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-gradient-to-br from-red-500 to-pink-500 rounded-full flex items-center justify-center shadow-lg">
                    <FaUser className="text-white text-sm sm:text-base" />
                  </div>
                  <div className="hidden sm:block">
                    <p className="font-semibold text-gray-900 text-sm sm:text-base">{userInfo.name}</p>
                    <p className="text-xs sm:text-sm text-gray-500">{getAuth().currentUser?.email}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Main Content */}
          <div className="container mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-4 sm:py-6 lg:py-8">
            <div className="flex flex-col xl:flex-row space-y-6 lg:space-y-0 xl:space-x-8">
              {/* Sidebar */}
              <div className="w-full xl:w-1/3">
                <div className="bg-white rounded-xl border border-gray-100 shadow-sm p-4 sm:p-6 lg:sticky lg:top-8">
                  <div className="flex items-center space-x-3 mb-6 sm:mb-8">
                    <div className="w-8 h-8 sm:w-10 sm:h-10 bg-gradient-to-br from-red-500 to-pink-500 rounded-full flex items-center justify-center shadow-lg">
                      <FaUserCog className="text-white text-sm" />
                    </div>
                    <h3 className="text-lg sm:text-xl font-bold text-gray-900">
                      Account Menu
                    </h3>
                  </div>
                  <nav className="space-y-2 sm:space-y-3">
                    <button
                      onClick={() => handleSectionClick("Account Settings")}
                      className={`w-full flex items-center justify-between px-4 sm:px-6 py-3 sm:py-4 rounded-xl transition-all duration-200 font-medium text-sm sm:text-base ${
                        activeSection === "Account Settings"
                          ? "bg-gradient-to-r from-red-500 to-pink-500 text-white shadow-lg"
                          : "text-gray-600 hover:bg-gray-50 hover:text-gray-800 border border-gray-100 hover:border-gray-200"
                      }`}
                    >
                      <div className="flex items-center space-x-2 sm:space-x-3">
                        <FaUserCog className="text-sm" />
                        <span>Account Settings</span>
                      </div>
                      <FaChevronRight className="text-xs" />
                    </button>
                    <button
                      onClick={() => handleSectionClick("Order History")}
                      className={`w-full flex items-center justify-between px-4 sm:px-6 py-3 sm:py-4 rounded-xl transition-all duration-200 font-medium text-sm sm:text-base ${
                        activeSection === "Order History"
                          ? "bg-gradient-to-r from-red-500 to-pink-500 text-white shadow-lg"
                          : "text-gray-600 hover:bg-gray-50 hover:text-gray-800 border border-gray-100 hover:border-gray-200"
                      }`}
                    >
                      <div className="flex items-center space-x-2 sm:space-x-3">
                        <FaHistory className="text-sm" />
                        <span>Order History</span>
                      </div>
                      <FaChevronRight className="text-xs" />
                    </button>
                    <button
                      onClick={() => handleSectionClick("Shipping Addresses")}
                      className={`w-full flex items-center justify-between px-4 sm:px-6 py-3 sm:py-4 rounded-xl transition-all duration-200 font-medium text-sm sm:text-base ${
                        activeSection === "Shipping Addresses"
                          ? "bg-gradient-to-r from-red-500 to-pink-500 text-white shadow-lg"
                          : "text-gray-600 hover:bg-gray-50 hover:text-gray-800 border border-gray-100 hover:border-gray-200"
                      }`}
                    >
                      <div className="flex items-center space-x-2 sm:space-x-3">
                        <FaShippingFast className="text-sm" />
                        <span>Shipping Addresses</span>
                      </div>
                      <FaChevronRight className="text-xs" />
                    </button>
                    <button
                      onClick={() => {
                        signOut(getAuth()).then(() => {
                          window.location.href = "/";
                        });
                      }}
                      className="w-full flex items-center justify-between px-4 sm:px-6 py-3 sm:py-4 rounded-xl text-gray-600 hover:bg-red-50 hover:text-red-600 transition-all duration-200 font-medium text-sm sm:text-base border border-gray-100 hover:border-red-200"
                    >
                      <div className="flex items-center space-x-2 sm:space-x-3">
                        <FaSignOutAlt className="text-sm" />
                        <span>Logout</span>
                      </div>
                      <FaChevronRight className="text-xs" />
                    </button>
                  </nav>
                </div>
              </div>

              {/* Main Content */}
              <div
                className="w-full xl:w-2/3"
                ref={mainContentRef}
              >
                <div className="bg-white rounded-xl border border-gray-100 shadow-sm p-4 sm:p-6 lg:p-8">
                  <div className="flex items-center space-x-3 sm:space-x-4 mb-6 sm:mb-8">
                    <div className="w-1 h-6 sm:h-8 bg-gradient-to-r from-red-500 to-pink-500 rounded-full"></div>
                    <div>
                      <h3 className="text-xl sm:text-2xl font-bold text-gray-900">
                        {activeSection}
                      </h3>
                      <p className="text-gray-500 text-sm sm:text-base">Manage your account and preferences</p>
                    </div>
                  </div>
                  {renderSectionContent()}
                </div>
              </div>
            </div>
          </div>

          {/* Modal */}
          {isModalOpen && (
            <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-2 sm:p-4 backdrop-blur-sm">
              <div className="bg-white rounded-2xl w-full max-w-lg p-4 sm:p-6 lg:p-8 shadow-2xl transform transition-all duration-300 scale-100 max-h-[90vh] overflow-y-auto">
                {/* Header */}
                <div className="flex items-center justify-between mb-6 sm:mb-8">
                  <div className="flex items-center space-x-3 sm:space-x-4">
                    <div className="w-10 h-10 sm:w-12 sm:h-12 bg-gradient-to-br from-red-500 to-pink-500 rounded-full flex items-center justify-center shadow-lg">
                      <FaMapMarkerAlt className="text-white text-base sm:text-lg" />
                    </div>
                    <div>
                      <h2 className="text-xl sm:text-2xl font-bold text-gray-900">
                        Edit Shipping Address
                      </h2>
                      <p className="text-gray-500 text-xs sm:text-sm mt-1">Update your delivery information</p>
                    </div>
                  </div>
                  <button
                    onClick={handleCloseModal}
                    className="w-8 h-8 sm:w-10 sm:h-10 bg-gray-100 rounded-full flex items-center justify-center text-gray-400 hover:text-gray-600 hover:bg-gray-200 transition-all duration-200 hover:scale-110"
                  >
                    <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                </div>

                {/* Form */}
                <form onSubmit={(e) => { e.preventDefault(); handleSaveClick(); }} className="space-y-4 sm:space-y-6">
                  {/* Personal Information Section */}
                  <div className="space-y-3 sm:space-y-4">
                    <div className="flex items-center space-x-2 mb-3 sm:mb-4">
                      <div className="w-1 h-3 sm:h-4 bg-red-500 rounded-full"></div>
                      <h3 className="font-semibold text-gray-800 text-sm sm:text-base">Personal Information</h3>
                    </div>
                    
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 sm:gap-4">
                      <div className="space-y-2">
                        <label className="block text-xs sm:text-sm font-semibold text-gray-700">
                          <div className="flex items-center space-x-2">
                            <FaUser className="text-red-500 text-xs sm:text-sm" />
                            <span>Full Name</span>
                            <span className="text-red-500 text-sm sm:text-lg">*</span>
                          </div>
                        </label>
                        <input
                          type="text"
                          value={address.name}
                          onChange={(e) =>
                            setaddress({ ...address, name: e.target.value })
                          }
                          placeholder="Enter your full name"
                          className="w-full p-3 sm:p-4 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent transition-all duration-200 bg-gray-50 hover:bg-white text-sm sm:text-base"
                        />
                      </div>
                      
                      <div className="space-y-2">
                        <label className="block text-xs sm:text-sm font-semibold text-gray-700">
                          <div className="flex items-center space-x-2">
                            <FaPhone className="text-red-500 text-xs sm:text-sm" />
                            <span>Phone Number</span>
                            <span className="text-red-500 text-sm sm:text-lg">*</span>
                          </div>
                        </label>
                        <input
                          type="tel"
                          value={address.mobile}
                          onChange={(e) =>
                            setaddress({ ...address, mobile: e.target.value })
                          }
                          placeholder="Enter your phone number"
                          className="w-full p-3 sm:p-4 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent transition-all duration-200 bg-gray-50 hover:bg-white text-sm sm:text-base"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Address Information Section */}
                  <div className="space-y-3 sm:space-y-4">
                    <div className="flex items-center space-x-2 mb-3 sm:mb-4">
                      <div className="w-1 h-3 sm:h-4 bg-blue-500 rounded-full"></div>
                      <h3 className="font-semibold text-gray-800 text-sm sm:text-base">Address Details</h3>
                    </div>
                    
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 sm:gap-4">
                      <div className="space-y-2">
                        <label className="block text-xs sm:text-sm font-semibold text-gray-700">
                          <div className="flex items-center space-x-2">
                            <FaMapMarkerAlt className="text-blue-500 text-xs sm:text-sm" />
                            <span>City</span>
                          </div>
                        </label>
                        <input
                          type="text"
                          value={address.city}
                          onChange={(e) =>
                            setaddress({ ...address, city: e.target.value })
                          }
                          placeholder="Enter your city"
                          className="w-full p-3 sm:p-4 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 bg-gray-50 hover:bg-white text-sm sm:text-base"
                        />
                      </div>
                      
                      <div className="space-y-2">
                        <label className="block text-xs sm:text-sm font-semibold text-gray-700">
                          <div className="flex items-center space-x-2">
                            <FaMapMarkerAlt className="text-blue-500 text-xs sm:text-sm" />
                            <span>Unit/Apt Number</span>
                          </div>
                        </label>
                        <input
                          type="text"
                          value={address.unit_number}
                          onChange={(e) =>
                            setaddress({
                              ...address,
                              unit_number: e.target.value,
                            })
                          }
                          placeholder="Optional"
                          className="w-full p-3 sm:p-4 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 bg-gray-50 hover:bg-white text-sm sm:text-base"
                        />
                      </div>
                    </div>
                    
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
                      <div className="space-y-2">
                        <label className="block text-xs sm:text-sm font-semibold text-gray-700">
                          <div className="flex items-center space-x-2">
                            <FaMapMarkerAlt className="text-green-500 text-xs sm:text-sm" />
                            <span>Country</span>
                            <span className="text-red-500 text-sm sm:text-lg">*</span>
                          </div>
                        </label>
                        <select
                          value={address.country}
                          onChange={handleCountryChange}
                          required
                          className="w-full p-3 sm:p-4 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all duration-200 bg-gray-50 hover:bg-white text-sm sm:text-base"
                        >
                          <option value="">Select Country</option>
                          <option value="Canada">Canada</option>
                          <option value="United States">United States</option>
                        </select>
                      </div>
                      
                      <div className="space-y-2">
                        <label className="block text-xs sm:text-sm font-semibold text-gray-700">
                          <div className="flex items-center space-x-2">
                            <FaMapMarkerAlt className="text-green-500 text-xs sm:text-sm" />
                            <span>State/Province</span>
                            <span className="text-red-500 text-sm sm:text-lg">*</span>
                          </div>
                        </label>
                        <select
                          value={address.state}
                          required
                          onChange={(e) =>
                            setaddress({ ...address, state: e.target.value })
                          }
                          className="w-full p-3 sm:p-4 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all duration-200 bg-gray-50 hover:bg-white text-sm sm:text-base"
                        >
                          <option value="">Select State</option>
                          <option value="Ontario">Ontario</option>
                          <option value="Quebec">Quebec</option>
                          <option value="British Columbia">British Columbia</option>
                          <option value="Alberta">Alberta</option>
                        </select>
                      </div>
                      
                      <div className="space-y-2 sm:col-span-2 lg:col-span-1">
                        <label className="block text-xs sm:text-sm font-semibold text-gray-700">
                          <div className="flex items-center space-x-2">
                            <FaMapMarkerAlt className="text-green-500 text-xs sm:text-sm" />
                            <span>Postal Code</span>
                            <span className="text-red-500 text-sm sm:text-lg">*</span>
                          </div>
                        </label>
                        <input
                          type="text"
                          value={address.zip}
                          onChange={(e) =>
                            setaddress({ ...address, zip: e.target.value })
                          }
                          placeholder="A1A 1A1"
                          className="w-full p-3 sm:p-4 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all duration-200 bg-gray-50 hover:bg-white text-sm sm:text-base"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Help Text */}
                  <div className="bg-blue-50 border border-blue-200 rounded-xl p-3 sm:p-4">
                    <div className="flex items-start space-x-2 sm:space-x-3">
                      <div className="w-5 h-5 sm:w-6 sm:h-6 bg-blue-500 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                        <span className="text-white text-xs font-bold">i</span>
                      </div>
                      <div>
                        <p className="text-xs sm:text-sm text-blue-800 font-medium mb-1">Address Information</p>
                        <p className="text-xs sm:text-sm text-blue-700">
                          Fields marked with <span className="text-red-500 font-bold">*</span> are required. 
                          This information will be used for order delivery.
                        </p>
                      </div>
                    </div>
                  </div>
                </form>

                {/* Action Buttons */}
                <div className="flex flex-col sm:flex-row space-y-3 sm:space-y-0 sm:space-x-4 mt-6 sm:mt-8 pt-4 sm:pt-6 border-t border-gray-200">
                  <button
                    onClick={handleCloseModal}
                    className="flex-1 px-4 sm:px-6 py-3 sm:py-4 border border-gray-300 text-gray-700 rounded-xl hover:bg-gray-50 transition-all duration-200 font-medium text-sm sm:text-base"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleSaveClick}
                    className="flex-1 px-4 sm:px-6 py-3 sm:py-4 bg-gradient-to-r from-red-600 to-pink-600 text-white rounded-xl hover:from-red-700 hover:to-pink-700 transition-all duration-200 font-medium shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 text-sm sm:text-base"
                  >
                    Save Address
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      ) : (
        <Profileempty />
      )}
    </>
  );
};

export default ProfilePage;
